import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpParams
} from '@angular/common/http';
import { StoreService } from '@root/shared/service/store.service';
import { Observable } from 'rxjs/Observable';
import { VERSION } from '@root/config';

@Injectable()
export class ParamsFilterInterceptor implements HttpInterceptor {
  // private operatorId;
  private clientInfo = this.getOSInfo();
  constructor(private storeService: StoreService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const operatorId = this.cacheOperatorId();

    let filteredParams = new HttpParams();
    const keys = req.params.keys();

    // tslint:disable-next-line:no-unused-expression
    keys && keys.forEach(key => {
      if (this.isValid(req.params.get(key))) {
        filteredParams = filteredParams.append(key, req.params.get(key));
      }
    });
    filteredParams = filteredParams
      .append('opid', operatorId)
      .append('opclient', this.clientInfo);

    const headers = req.headers.append('hostex-app-version', VERSION);

    return next.handle(req.clone({ params: filteredParams, headers }));
  }

  private isValid(value) {
    return !['undefined', 'null', '', undefined, null].includes(value);
  }

  private cacheOperatorId() {
    // if (!this.operatorId) {
    //   this.operatorId = this.storeService.get('operator_id', 1);
    // }
    // return this.operatorId;

    return this.storeService.get('operator_id', 1);
  }

  private getOSInfo() {
    let name = 'unknown';
    let browser = 'unknown';

    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf('win') !== -1) {
      name = 'Win';
    } else if (userAgent.indexOf('mac') !== -1) {
      name = 'Mac';
    } else if (userAgent.indexOf('linux') !== -1) {
      name = 'Linux';
    }

    if (userAgent.indexOf('edg') !== -1) {
      browser = 'Edge';
    } else if (userAgent.indexOf('firefox') !== -1) {
      browser = 'Firefox';
    } else if (userAgent.indexOf('chrome')) {
      browser = 'Chrome';
    } else if (userAgent.indexOf('safari')) {
      browser = 'Safari';
    } 

    return `Web-${name}-${browser}`;
  }
}
